export default __webpack_public_path__ + "static/media/LandingPageBackground.af4622b1.png";